<template>
  <div class="ComBox">
    <div
      :style="`font-size: ${changeDevicePixelRatio(element.style.titleFontSize||18)}px;padding-top: ${changeDevicePixelRatio(14)}px;`"
      class="title"
    >{{ title }}</div>
    <slot></slot>
  </div>
</template>

<script>
import { changeDevicePixelRatio } from '@/utils/changeComponentsSizeWithScale'
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    element: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  computed: {
    titleFontSize() {
      const px = Math.ceil(18 / window.devicePixelRatio)
      return px
    }
  },

  created() {},

  methods: {
    changeDevicePixelRatio
  }
}
</script>

<style lang="scss" scoped>
.ComBox {
  width: 100%;
  height: 100%;

  border-radius: 4px;
  // background: rgba(4, 32, 104,.7);
  .title {
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    padding-top: 14px;
    line-height: 1;
  }
}
</style>
